import React, { useState } from "react";
import axios from "axios";
import url from "../../services/url";
import { If } from "react-condition";
import { useHistory } from "react-router-dom";
import Loginimg from "../../images/Maxicus_logo.png";
import { Button, Input, Radio } from "antd";
import { MailOutlined, MobileOutlined } from "@ant-design/icons";
import OtpVerification from "./OTP";
import ConfirmPassword from "./ConfirmPassword";

const indianPhoneRegex = /^[6-9]\d{9}$/;
const emailRegex = /^(?!\.)(?!.*\.\.)[^\s@]+(?<!\.)@[^\s@]+\.[^\s@]+$/;

function ResetPassword() {
  const [loginType, setLoginType] = useState("email");
  const [emailOrPhone, setEmailOrPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [alert, setAlert] = useState("");
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [confirmPassOpen, setConfirmPassOpen] = useState(false);

  const history = useHistory();

  const handleChange = (e) => {
    let loginType = "email";
    let value = String(e.target.value)?.trim();
    value = value.replace(/[^a-zA-Z0-9.@]/g, "");
    const firstTwoLetter = value?.slice(0, 2);

    if (
      firstTwoLetter &&
      firstTwoLetter.length === 2 &&
      !isNaN(Number(firstTwoLetter))
    ) {
      loginType = "phone";
    }

    if (
      value?.includes("@") ||
      value?.includes(".") ||
      /[a-zA-Z]/.test(value)
    ) {
      loginType = "email";
    }

    setEmailOrPhone(value);
    setLoginType(loginType);
  };

  const resetPassword = async (e) => {
    e.preventDefault();
    setAlert("");
    setError({});

    const isProceed = checkValidation();

    if (!isProceed) return;

    try {
      setLoading(true);
      const result = await axios.post(
        url("candidate/forgetPassword"),
        {
          ...(loginType === "email"
            ? { email: emailOrPhone }
            : { phone: emailOrPhone }),
        },
        { headers: { "Content-Type": "application/json" } },
      );

      if (result.status === 200) {
        setOtpSent(true);
      }
    } catch (err) {
      console.error(err);
      setAlert(
        err.response?.data?.message || "An error occurred. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  };

  async function onClickVerifyOtp(otp) {
    setAlert("");
    try {
      if (!otp || otp.length !== 6) {
        setAlert("Please enter a valid 6-digit OTP.");
        return;
      }

      setLoading(true);
      setOtp(otp);
      const result = await axios.post(
        url("candidate/verifyForgetPasswordOTP"),
        {
          ...(loginType === "email"
            ? { email: emailOrPhone }
            : { phone: emailOrPhone }),
          OTP: otp,
        },
      );

      if (result.status === 200) {
        setConfirmPassOpen(true);
      }
    } catch (error) {
      console.error(error);
      setAlert(
        error.response?.data?.message || "An error occurred. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  }

  const checkValidation = () => {
    let e = {};
    const value = emailOrPhone.trim();

    if (!value) {
      e.emailOrPhone = "Email or mobile number is required.";
    }

    if (loginType === "phone" && value) {
      if (!indianPhoneRegex.test(value)) {
        e.emailOrPhone = "Enter a valid mobile number.";
      }
    }

    if (loginType === "email" && value) {
      if (!emailRegex.test(value)) {
        e.emailOrPhone = "Enter a valid email address.";
      }
    }

    setError(e);

    return Object.keys(e).length === 0;
  };

  const inputStyles = {
    padding: "10px 11px",
    fontSize: "16px",
    lineHeight: 1.5,
    borderRadius: "8px",
  };

  const btnStyle = {
    height: 48,
    borderRadius: 10,
    fontWeight: 500,
    fontSize: 16,
    background:
      "linear-gradient(41deg, rgb(241,120,35) 0%, rgb(248,166,27) 100%)",
    border: "none",
  };

  const IS_EMAIL = loginType === "email";

  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-xl-10 col-lg-12 col-md-9">
          <div className="card o-hidden border-0 shadow-lg my-5">
            <div className="card-body p-0">
              <div className="row">
                <div className="col-lg-6 d-none d-lg-block bg-login-image"></div>
                <div className="col-lg-6">
                  <div className="px-4 py-10">
                    <div className="">
                      <div className="text-center">
                        <img src={Loginimg} alt="Login" className="mb-1" />
                      </div>
                      <small className="app-name mb-2">Digital Hiring</small>
                      <hr />
                    </div>
                    {!otpSent ? (
                      <div className="w-full">
                        <div>
                          <h1 className="h4 text-gray-900 mb-3 mt-3 text-center">
                            Update Password
                          </h1>
                        </div>
                        <div className="">
                          <p>{`We will send a One-Time Password (OTP) to your registered ${loginType === "email" ? "email" : "mobile number"}.`}</p>
                        </div>
                        <If test={alert !== ""}>
                          <div className="alert alert-danger">{alert}</div>
                        </If>
                        <form className="user">
                          <div className="mb-[24px]">
                            <Input
                              type="text"
                              onChange={handleChange}
                              value={emailOrPhone}
                              style={inputStyles}
                              name="email"
                              allowClear
                              prefix={
                                <span
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 6,
                                  }}
                                >
                                  <span className="pr-1">
                                    {IS_EMAIL ? (
                                      <MailOutlined />
                                    ) : (
                                      <MobileOutlined />
                                    )}
                                  </span>
                                  {!IS_EMAIL && (
                                    <span
                                      style={{ fontSize: 16, color: "#555" }}
                                    >
                                      +91
                                    </span>
                                  )}
                                </span>
                              }
                              size="large"
                              placeholder={`Enter email or mobile number`}
                              status={
                                error?.emailOrPhone && error?.emailOrPhone
                                  ? "error"
                                  : ""
                              }
                            />
                            {error?.emailOrPhone && (
                              <div className="text-[#ff4d4f]">
                                {error?.emailOrPhone}
                              </div>
                            )}
                          </div>
                          <div>
                            <Button
                              htmlType="submit"
                              loading={loading}
                              onClick={resetPassword}
                              className="w-100"
                              type="primary"
                              value="large"
                              iconPlacement="end"
                              style={btnStyle}
                            >
                              Send OTP
                            </Button>
                          </div>

                          <div className="flex justify-center mt-4">
                            <a
                              onClick={() => history.push("/careers")}
                              className="underline underline-offset-4"
                              style={{
                                textDecoration: "underline",
                                textDecorationOffset: 3,
                                color: "darkblue",
                                fontWeight: 400,
                              }}
                            >
                              Back to Login
                            </a>
                          </div>
                        </form>
                      </div>
                    ) : (
                      <>
                        {confirmPassOpen ? (
                          <>
                            <ConfirmPassword
                              otp={otp}
                              loginType={loginType}
                              value={emailOrPhone}
                            />
                          </>
                        ) : (
                          <>
                            <div className="mt-4 flex justify-center">
                              <OtpVerification
                                setAlert={setAlert}
                                emailOrPhone={emailOrPhone}
                                setIsOtpSent={setOtpSent}
                                alert={alert}
                                type={loginType}
                                handleVerify={onClickVerifyOtp}
                                reSendOtp={resetPassword}
                              />
                            </div>
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
